import React, { useState, useMemo, useEffect } from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import Select from 'react-select';

import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
// import Paymentdetailspage from './Vendorreporttable';
import Vendorproductpayment from './Vendorreporttable';
import { format, sub } from 'date-fns';
import { Link } from 'react-router-dom';
import Category from '../Pages/Category';



export default function Addproductmatrial() {
    const token = localStorage.getItem('token');
    const [venderpaymentlist, setvandorpaymentlist] = useState([]);
    const [selectedVendorId, setSelectedVendorId] = useState(null);
    const [selectedCategoryIdReportList, setselectedCategoryIdReportList] = useState(null);

    const initialFields = {
        VenderName: '',
        AccountName: '',
        CustumerName: '',
        ComponentName: '',
        CategoryName: '',
        Amount: '',
        Mode: '',
    };
    const [fields, setFields] = useState(initialFields);
    const [loading, setLoading] = useState(false);
    const [selectoption, setSelectoption] = useState(null);
    const [subcomponentOrderId, setsubcomponentOrderId] = useState(null);
    const [venderlist, setVenderlist] = useState([]);
    const [vendorreprotlist, setvendorreprotlist] = useState([]);
    const [custumerlist, setCustumerlist] = useState([]);
    const [accountlist, setAccountlist] = useState([]);
    const [errors, setErrors] = useState({});
    const [counters, setCounters] = useState([]);
    const [vendorData, setVendorData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [componentData, setComponentData] = useState([]);
    const [orderList, setOrderList] = useState([]);
    const [filteredComponents, setFilteredComponents] = useState([]);
    const [TotalcategoryCostArray, setTotalcategoryCostArray] = useState([]);
    const [subcomponentOrder, setsubcomponentOrder] = useState([]);
    const [TotalAmount, setTotalAmount] = useState('');
    const [account_type, setaccounttype] = useState('');
    const [OrderId, setOrderId] = useState('');

    const handleChange = (value, name, subcomponent_order) => {
        console.warn("dfgdfg", value, name, subcomponent_order)
        if (name === 'Mode') {
            setSelectoption(value);
            setFields({ ...fields, Mode: value.value });
        } else if (name === 'VenderName') {
            setFields({ ...fields, VenderName: value });
            setSelectedVendorId(value);
            setsubcomponentOrderId(subcomponent_order)

        } else if (name === 'AccountName') {
            setFields({ ...fields, AccountName: value });
            const filtered = accountlist.filter(account => account.id === parseInt(value));

            setaccounttype(filtered[0].account_type)
        } else if (name === 'CategoryName') {
            setFields({ ...fields, CategoryName: value });
            if (!value) {

                setTotalAmount('')
            }

            const filtered = componentOptions.filter(component => component.category_Id === parseInt(value));
            // setFilteredComponents(filtered);
            console.log("kkkkkkkk", filtered);
        } else if (name === 'ComponentName') {

            setFields({ ...fields, ComponentName: value });
        } else if (name === 'CustumerName') {
            setFields({ ...fields, CustumerName: value });
            VenderView(value);
            setOrderId(value)
            fetchOrderlist(value);
            if (!value) {

                setTotalAmount('')
            }
        }
        else if (name === 'CategoryName') {
            setFields({ ...fields, CategoryName: value });
            VenderView(value);
            fetchOrderlist(value);
        }
    };
    const componentOptions = componentData.map((item) => ({
        value: item.id,
        label: item.name,
        category_Id: item.category_Id,
    }));
    console.log("opppp", componentOptions);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFields({ ...fields, [name]: value });
    };

    const validateFields = () => {
        const errors = {};
        if (!fields.VenderName) errors.VenderName = 'Vendor Name is required';
        // if (!fields.CustumerName) errors.CustumerName = 'Custumer Name is required';
        if (!fields.AccountName) errors.AccountName = 'account name is required';
        if (!fields.Amount) errors.Amount = 'Amount is required';
        // if (!fields.Mode) errors.Mode = 'Account Mode is required';
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateFields();
        if (Object.keys(errors).length) {
            setErrors(errors);
            return;
        }
        setErrors({});
        setLoading(true);
        const amountToSend = fields.Amount.replace(/,/g, '');
        const payload = {
            vendor_id: fields.VenderName,
            create_order_id: fields.CustumerName,
            account_name: fields.AccountName,
            component_id: fields.ComponentName,
            category_id: fields.CategoryName,
            amount: amountToSend,
            manufacture: 'Manufacture',
            mode: account_type,
            id:subcomponentOrderId,
            date: fields.Date || new Date().toISOString().split("T")[0],
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Vendor-payment-store`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            if (response.data.status === 1) {
                toast.success(response.data.message);
                setFields(initialFields);
                setSelectoption(null);
                RowMatrialslist();
                fetchVendorReport();
                setTotalAmount('')
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error:', error);
            // toast.error('An error occurred');
        } finally {
            setLoading(false);
        }
    };

    // useEffect(() => {
    //     fetchOrderlist();
    // }, []);


    // const handleCategoryClick = (categoryId) => {
    //     // Ensure consistent type comparison
    //     const filtered = TotalcategoryCostArray.filter(
    //         component => component.category_id === categoryId
    //     );
    //     console.warn("Selected ID (Filtered):", selectedCategoryIdReportList);
    //     if (filtered.length > 0) {
    //     if(selectedCategoryIdReportList){
    //     const total_cost_priceoverall = filtered[0].total_cost_price - selectedCategoryIdReportList
    //     setTotalAmount(total_cost_priceoverall);
    // }
    // } else {
    //     console.warn("No matching category found in TotalcategoryCostArray.");
    // }
    //     // Check if filtered array has data before setting total amount



    //     const filteredsubcomponentOrder = subcomponentOrder.filter(
    //         component => component.category_id === categoryId
    //     ).map(component => ({
    //         value: component.component_id,
    //         label: component.component_name,
    //         value1: component.vender_id,
    //         label1: component.vendor_name,
    //     }));

    //     // Update filtered components for the Select dropdown
    //     setFilteredComponents(filteredsubcomponentOrder);
    //     console.warn("fdgfh", filteredsubcomponentOrder)

    // };

    const handleCategoryClick = (categoryId) => {
    };


    const fetchOrderlist = async (OrderlistID) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Order-view-product-list/${OrderlistID}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });

            console.warn("totalPriceee", response.data.rows.component_order);

            const componentOrder = response.data.rows?.component_order || [];
            const subcomponentOrder = response.data.rows?.sub_component_order || [];

            // Calculate category-wise total cost price
            const categoryWiseCost = componentOrder.reduce((acc, item) => {
                const categoryId = item.category_id;
                const costPrice = parseFloat(item.cost_price) || 0;

                if (!acc[categoryId]) {
                    acc[categoryId] = 0;
                }
                acc[categoryId] += costPrice;

                return acc;
            }, {});

            // Transform into an array of objects
            const categoryCostArray = Object.keys(categoryWiseCost).map(categoryId => ({
                category_id: categoryId,
                total_cost_price: categoryWiseCost[categoryId],
            }));

            console.warn("Category-wise Cost Array:", categoryCostArray);
            setTotalcategoryCostArray(categoryCostArray);
            setsubcomponentOrder(subcomponentOrder);

            const totalCostPrice = response.data.rows?.total_cost_price || 0;
            setOrderList(response.data.data || []);


        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };




    useEffect(() => {
        VenderView();
        CategoryView();
        ComponentView();
    }, []);
    const VenderView = async (vendorId) => {
        try {
            let url = `${process.env.REACT_APP_API_URL}Vender-list`;
            const config = {
                method: 'get',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            };
            const response = await axios(config);
            setVendorData(response.data.data || []); // Set the vendor data in state
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        }
    };
    const CategoryView = async (vendorId) => {
        try {
            let url = `${process.env.REACT_APP_API_URL}category-list`;
            const config = {
                method: 'get',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            };
            const response = await axios(config);
            setCategoryData(response.data.data || []); // Set the vendor data in state

        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        }
    };
    const ComponentView = async (vendorId) => {
        try {
            let url = `${process.env.REACT_APP_API_URL}component-list`;
            const config = {
                method: 'get',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            };
            const response = await axios(config);
            setComponentData(response.data.data || []);
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        }
    };
    // useEffect(() => {
    //     const fetchVendor = async () => {
    //         try {
    //             const response = await axios.get(`${process.env.REACT_APP_API_URL}Vender-list`, {
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'x-access-token': token,
    //                 },
    //             });
    //             setVenderlist(response.data.data || []);
    //         } catch (error) {
    //             console.error('Error fetching Vendor:', error);
    //         }
    //     };

    //     fetchVendor();
    // }, [token]);

    useEffect(() => {
        const fetchCustumer = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}Custumer-name-list`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
                const filteredList = response.data.data.filter(item => item.manufacture === "Manufacture");
                setCustumerlist(filteredList || []);
            } catch (error) {
                console.error('Error fetching Vendor:', error);
            }
        };

        fetchCustumer();
    }, [token]);

    useEffect(() => {
        const fetchAccount = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}Account-list`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
                setAccountlist(response.data.data || []);
            } catch (error) {
                console.error('Error fetching Account:', error);
            }
        };

        fetchAccount();
    }, [token]);

    useEffect(() => {
        fetchVendorReport();
    }, [selectedVendorId]);

    // if (selectedVendorId) {
    const fetchVendorReportListByCategory = async (selectedCategoryId) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}Vendor-Vendor-Report-ListByCategory`,
                {
                    create_order_id: OrderId, // Pass the create_order_id
                    category_id: selectedCategoryId, // Pass the category_id
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                }
            );

            const totalamount = response.data.data.total_amount ?? 0;

            const filtered = TotalcategoryCostArray.filter(component => component.category_id === selectedCategoryId);
            if (filtered.length > 0) {
                // setTotalAmount(total_cost_priceoverall);
                if (totalamount && !isNaN(totalamount)) {
                    const total_cost_priceoverall = filtered[0].total_cost_price - totalamount;
                    setTotalAmount(total_cost_priceoverall);
                } else {
                    const total_cost_priceoverall = filtered[0].total_cost_price
                    setTotalAmount(total_cost_priceoverall);
                    console.warn("selectedCategoryIdReportList is not a valid number.", total_cost_priceoverall);
                }
                // fetchVendorReportListByCategory(categoryId)
            } else {
                setTotalAmount('');
                console.warn("No matching category found in TotalcategoryCostArray.");
            }
            // Filter subcomponentOrder based on categoryId and map to the desired structure
            const filteredsubcomponentOrder = subcomponentOrder.filter(component => component.category_id === selectedCategoryId)
                .map(component => ({
                    value: component.component_id,
                    label: component.component_name,
                    value1: component.vender_id,
                    label1: component.vendor_name,
                    subcomponent_orderId: component.id
                }));

            // Update filtered components for the Select dropdown
            setFilteredComponents(filteredsubcomponentOrder);

            // Log the filtered subcomponents for debugging


        } catch (error) {
            console.error('Error fetching Vendor report:', error);
        }
    };

    const fetchVendorReport = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Vendor-report-list/${selectedVendorId}`,
                { vendor_id: selectedVendorId }, // Payload for the request
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });

            const filteredData = (response.data.data || []).filter(
                item => item.manufacture === 'Manufacture'
            );

            setvendorreprotlist(filteredData);
        } catch (error) {
            console.error('Error fetching Vendor report:', error);
        }
    };
    // }
    const options = [
        { value: 'Online', label: 'Online' },
        { value: 'Cash', label: 'Cash' },
    ];

    const title = "View Payment Details";
    const title1 = "Vendor Report";

    const RowMatrialslist = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Vendor-payment-list`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            setvandorpaymentlist(response.data.data.data || []);
            console.warn("fgfg", response.data.data.data)
        } catch (error) {
            console.error('Error fetching Vendor:', error);
        }
    };

    useEffect(() => {
        RowMatrialslist();
    }, [token]);

    const transformedVendorPaymentList = useMemo(() => {
        return venderpaymentlist.map(item => ({
            ...item,
            totaldue: item.total_payments - item.totalSum,
        }));
    }, [venderpaymentlist]);

    // const Vendorproduct = useMemo(
    //     () => [
    //         {
    //             Header: 'Sr No',
    //             accessor: (row, i) => i + 1,
    //         },
    //         {
    //             Header: 'Customer Name',
    //             accessor: 'customer_name',
    //         },
    //         {
    //             Header: 'Vendor Name',
    //             accessor: 'vendor_name',
    //         },
    //         {
    //             Header: 'Total Receive',
    //             accessor: 'totalSum',
    //         },
    //         {
    //             Header: 'Total Paid',
    //             accessor: 'total_payments',
    //         },
    //         {
    //             Header: 'Total Due',
    //             accessor: 'totaldue',
    //             Cell: ({ value }) => {
    //                 const formattedValue = value >= 0 ? `+${value}` : value;
    //                 return <span>{formattedValue}</span>;
    //             },
    //         },
    //     ],
    //     []
    // );
    const Vendorproduct1 = useMemo(
        () => [
            {
                Header: 'Sr No',
                accessor: (row, i) => i + 1,
            },
            {
                Header: 'Date',
                accessor: 'created_at',
                Cell: ({ value }) => {
                    return format(new Date(value), 'dd-MM-yyyy');
                },
            },
            {
                Header: 'Customer Name',
                accessor: 'customer_name',
            },
            {
                Header: 'Vendor Name',
                accessor: 'vendor_name',
            },

            {
                Header: 'Receive',
                accessor: 'amount',
                Cell: ({ value }) => (
                    value !== undefined ? (
                        new Intl.NumberFormat().format(value)
                    ) : null
                ),
            },
            {
                Header: 'Account',
                accessor: 'account_name',
            },
            {
                Header: 'Payment Mode',
                accessor: 'mode',
            },


        ],
        []
    );



    return (
        <div>
            <Card>
                <Card.Header className='d-flex justify-content-between align-items-center'>
                    <Card.Title className='mb-0'>Select Payment</Card.Title>
                    {/* <Col md={6} className="d-flex justify-content-end"> */}
                    <Link to="/vendermanagement">
                        <Button variant="dark">Back</Button>
                    </Link>
                    {/* </Col> */}
                </Card.Header>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={4} sm={12}>
                                <Form.Group>
                                    <Form.Label>Amount</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Amount"
                                        name="Amount"
                                        value={fields.Amount}
                                        onChange={e => {
                                            let value = e.target.value.replace(/,/g, '');
                                            if (!isNaN(value) || value === "") {
                                                value = new Intl.NumberFormat().format(value); // Format for display
                                                handleInputChange({ target: { name: 'Amount', value } });
                                            }
                                        }}
                                        style={{ borderColor: errors.Amount ? 'red' : '' }}
                                    />
                                </Form.Group>
                            </Col>


                            <Col md={4} sm={12}>
                                <Form.Group>
                                    <Form.Label>Customer Name</Form.Label>
                                    <Form.Select
                                        value={fields.CustumerName}
                                        onChange={(e) => handleChange(e.target.value, 'CustumerName')}
                                        style={{ borderColor: errors.CustumerName ? 'red' : '' }}
                                    >
                                        <option value="">Select Customer Name</option>
                                        {custumerlist.map((vendor) => (
                                            <option key={vendor.id} value={vendor.id}>
                                                {vendor.customer_name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col md={4} sm={12}>
                                <Form.Group>
                                    <Form.Label>Product Category</Form.Label>
                                    <Form.Select
                                        value={fields.CategoryName}
                                        onChange={(e) => {
                                            const selectedId = e.target.value; // Get the selected category ID
                                            handleChange(selectedId, 'CategoryName'); // Pass it to the handleChange function
                                            fetchVendorReportListByCategory(selectedId); // Call a separate function for onclick logic
                                        }}
                                        style={{ borderColor: errors.CategoryName ? 'red' : '' }}
                                    >
                                        <option value="">Select Product Category</option>
                                        {categoryData.map((category) => (
                                            <option key={category.id} value={category.id}>
                                                {category.name}
                                            </option>
                                        ))}
                                    </Form.Select>

                                </Form.Group>
                            </Col>
                            <Col md={4} sm={12}>
                                <Form.Group>
                                    <Form.Label>Component</Form.Label>
                                    <Select
                                        className="component-form"
                                        value={filteredComponents.find(option => option.value === fields.ComponentName)}
                                        options={[...new Map(filteredComponents.map(option => [option.value1, option])).values()]}
                                        onChange={(selected) =>
                                            handleChange(selected ? selected.value : "", "ComponentName")
                                        }
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                borderColor: errors.ComponentName ? "red" : "",
                                            }),
                                        }}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={4} sm={12}>
                                <Form.Group>
                                    <Form.Label>Vendor Name</Form.Label>
                                    {/* <Form.Select
                                        value={filteredComponents.find(option => option.value1 === fields.VenderName)?.value1 || ''}
                                        onChange={(e) => handleChange(e.target.value, 'VenderName', vendor.subcomponent_orderId)}
                                        style={{ borderColor: errors.VenderName ? 'red' : '' }}
                                    >
                                        <option value="">Select Vendor Name</option>
                                        {[...new Map(filteredComponents.map((vendor) => [vendor.value1, vendor,])).values()]
                                            .map((vendor) => (
                                                <option key={vendor.value1} value={vendor.value1}>
                                                    {vendor.label1}
                                                </option>
                                            ))}

                                    </Form.Select> */}
                                    <Form.Select
                                        value={filteredComponents.find(option => option.value1 === fields.VenderName)?.value1 || ''}
                                        onChange={(e) => {
                                            const selectedVendor = filteredComponents.find(option => option.value1 === e.target.value);
                                            handleChange(e.target.value, 'VenderName', selectedVendor?.subcomponent_orderId); // ✅ Pass subcomponent ID
                                        }}
                                        style={{ borderColor: errors.VenderName ? 'red' : '' }}
                                    >
                                        <option value="">Select Vendor Name</option>
                                        {[...new Map(filteredComponents.map((vendor) => [vendor.value1, vendor])).values()]
                                            .map((vendor) => (
                                                <option key={vendor.value1} value={vendor.value1}>
                                                    {vendor.label1}
                                                </option>
                                            ))}
                                    </Form.Select>

                                </Form.Group>
                            </Col>


                            <Col md={4} sm={12}>
                                <Form.Group>
                                    <Form.Label>Account Name</Form.Label>
                                    <Form.Select
                                        value={fields.AccountName}
                                        onChange={(e) => handleChange(e.target.value, 'AccountName')}
                                        style={{ borderColor: errors.AccountName ? 'red' : '' }}
                                    >
                                        <option value="">Select Account Name</option>
                                        {accountlist.map((vendor) => (
                                            <option key={vendor.id} value={vendor.id}>
                                                {vendor.account_name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={4} sm={12}>
                                <Form.Group>
                                    <Form.Label>Mode</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Amount"
                                        name="account_type"
                                        value={account_type}
                                        disabled
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={4} sm={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="custom-label">Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        placeholder="Date"
                                        value={fields.Date || new Date().toISOString().split("T")[0]}
                                        onFocus={(e) => e.target.showPicker()}
                                        onChange={handleChange('Date')}
                                        className={errors.Date ? 'is-invalid' : ''}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} sm={12}>
                                <Form.Group>
                                    <Form.Label>Total Balance of Category Cost Price</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className="disabled_input"
                                        placeholder="Product Category Amt"
                                        name="Product Category Amt"
                                        disabled
                                        value={new Intl.NumberFormat().format(
                                            (Number(String(TotalAmount).replace(/,/g, '')) - Number(String(fields.Amount).replace(/,/g, '')))
                                        )}
                                        style={{ borderColor: errors.Amount ? 'red' : '' }}
                                    />
                                </Form.Group>
                            </Col>


                            <Col lg={12} sm={12}>
                                <div className="d-flex justify-content-end">
                                    <Button type="submit" className="btn-added" disabled={loading}>
                                        {loading ? 'Submitting...' : 'Pay'}
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                    <hr />
                    {/* <Paymentdetailspage title={title} columns={Vendorproduct} data={transformedVendorPaymentList} /> */}
                    {/* <hr></hr> */}
                    {/* <div className='row justify-content-center'>
                        <Col md={3} sm={12}>
                            <Form.Group>
                                <Form.Select
                                    value={fields.VenderName}
                                    onChange={(e) => handleChange(e.target.value, 'VenderName')}
                                    style={{ borderColor: errors.VenderName ? 'red' : '' }}
                                >
                                    <option value="">Select Vendor Name</option>
                                    {vendorData.map((vendor) => (
                                        <option key={vendor.id} value={vendor.id}>
                                            {vendor.vendor_name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </div> */}
                    <Vendorproductpayment title={title1} columns={Vendorproduct1} data={vendorreprotlist} />
                    {vendorreprotlist.length > 0 ? (
                        null
                    ) : (
                        <p style={{ color: "red", textAlign: "center" }}>Please select a vendor to view payment details.</p>
                    )}
                </Card.Body>
            </Card>
            <ToastContainer />
        </div>
    );
}
